<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs @tab-click="dianji">
        <!-- 内容过滤 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.regex") }}</span>
          <div class="main">
            <p>
              <!-- 添加过滤规则 -->
              <el-button
                @click="tan()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addrule") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
                v-loading="loading1"
              >
                <!-- 添加过滤规则 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="100"
                >
                </el-table-column>

                <!-- 分数 -->

                <el-table-column
                  prop="SCORE"
                  :label="$t('table1.score')"
                  width="120"
                >
                </el-table-column>
                <!-- 表达式类型 -->

                <el-table-column
                  prop="SHOWTYPE"
                  :label="$t('table1.type')"
                  width="140"
                >
                </el-table-column>
                <!-- 信头key -->

                <el-table-column prop="HEADER_KEY" :label="$t('table1.header')">
                </el-table-column>
                <!-- 正则表达式过滤规则 -->

                <el-table-column prop="REGEX" :label="$t('table1.rule')">
                </el-table-column>
                <el-table-column
                  prop="POLICY_TYPE"
                  :label="$t('table1.policy')"
                  width="120"
                >
                </el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                    <!-- 编辑 -->

                    <el-button
                      type="text"
                      size="small"
                      @click="save01(scope.$index, scope.row)"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_relay_domain' }"
            >
              <div class="pop_up_text pop_up_text_relay_domain">
                <span class="span_pad"></span> {{ $t("table1.addrule") }}
              </div>
              <p></p>

              <div class="find">
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="type" @change="changyin01">
                      <el-option
                        v-for="item in type11"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <!--分数 -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Score") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="score" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="header_key" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--正则表达式过滤规则 -->
                  <div class="find-text" style="padding-right:12px;">
                    {{ $t("anti_gs1.RegexRule") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filterregex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--策略类型 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Policytype") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="policy_type" placeholder="请选择">
                      <el-option
                        v-for="item in type12"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存 -->

                <el-button
                  type="primary"
                  @click="save1"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消 -->

                <el-button type="danger" @click="save11">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div
              class="pop-up"
              v-show="tanchu1"
              v-drag="{ handle: '.pop_up_text_relay_domain_edit' }"
            >
              <div class="pop_up_text pop_up_text_relay_domain_edit">
                <span class="span_pad"></span> {{ $t("table1.addrule1") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="type" @change="changyin01">
                      <el-option
                        v-for="item in type11"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <!--分数 -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Score") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="score" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="header_key" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--正则表达式过滤规则 -->
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.RegexRule") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="filterregex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--策略类型 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Policytype") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="policy_type" placeholder="请选择">
                      <el-option
                        v-for="item in type12"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button
                  type="primary"
                  @click="save001"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <el-button type="danger" @click="save002">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu1"></div>
          </div>
        </el-tab-pane>
        <!-- IP白名单 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("tabs.ipw") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加IP白名单 -->

              <el-button
                @click="save2()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addwip") }}</el-button
              >
              <!-- 导入IP白名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.impwip") }}</el-button
              >

              <!-- 导出ip白名单-->

              <el-button
                @click="daochu()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.expwip") }}</el-button
              >
              <span class="main_text">{{ $t("anti_gs1.ipaddress") }}:</span>
              <el-input v-model="ipaddr" placeholder="" clearable></el-input>
              <el-button
                @click="search_ipw()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_ipw"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号-->
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- IP地址-->

                <el-table-column
                  prop="IPADDR"
                  :label="$t('table1.ipAddress')"
                  width="120"
                >
                </el-table-column>
                <!-- 到期时间-->

                <el-table-column
                  prop="EXPIRE"
                  :label="$t('table1.expire')"
                  width="120"
                >
                </el-table-column>
                <!-- VIP-->

                <el-table-column
                  prop="SHOW_IS_VIP"
                  :label="$t('anti_gs1.into_local')"
                  width="120"
                  v-if="this.isvip_show == 1"
                >
                </el-table-column>
                <!-- 描述-->

                <el-table-column prop="DESC" :label="$t('table1.description')">
                </el-table-column>
                <!-- 操作-->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_ipw"
                @current-change="handleCurrentChange_ipw"
                :current-page.sync="page"
                :page-sizes="this.q_page_size"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
            </div>

            <div
              class="pop-up"
              v-show="tanchu2"
              v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS">
                <span style="padding:0 14px"></span>{{ $t("table1.addwip") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.ipaddress") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="ipaddr"
                      placeholder=""
                      clearable
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.isvip_show == 1">
                  <!-- 加入本地网络vip-->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.into_local") }} :
                  </div>
                  <div class="block block1">
                    <el-checkbox v-model="isvip"></el-checkbox>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save21()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save22()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu2"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_ipw' }"
            >
              <div class="pop_up_text  pop_up_text_import_ipw">
                <span style="padding:0 14px"></span>{{ $t("table1.impwip") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      class="iupfile"
                      id="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button type="primary" size="mini" @click="save022">{{
                  $t("tan.up")
                }}</el-button>
                <el-button type="danger" @click="save23()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
              <!--  第一次 
                        <form class="form" id="f_upload_ipwl" name="f_upload_ipwl" method="post" enctype="multipart/form-data" action="api/adm/cgi/newspam.cgi">
                            <div class="item"><label></label>
                                <input type="hidden" name="sid" :value="sid11">
                                <input type="hidden" name="__mode" value="upload_ipwl">
                                <input type="hidden" name="screen" value="upload_ipwl_res.html">
                            </div>
                            <div class="item"><input name="upfile" type="file" id="iupfile" width="300"></div>
                            <div class="item"><label style="width:50px;"></label>
                                <el-button type="primary" @click="daoru1()">保存</el-button>
                                <el-button type="primary" @click="save24()">取消</el-button>
                            </div>
                        </form>
                        <ifrmae name='upload' id='uploader1'></iframe>
-->
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- IP黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.ipb") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加ip黑名单 -->

              <el-button
                @click="save3()"
                :disabled="$root.jurisdiction.only_query == 0"
              >
                {{ $t("table1.addbip") }}</el-button
              >
              <!-- 导入ip黑名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.impbip") }}</el-button
              >
              <!-- 导出ip黑名单 -->

              <el-button
                @click="daochu3()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.expbip") }}</el-button
              >
              <span class="main_text">{{ $t("anti_gs1.ipaddress") }}:</span>
              <el-input
                v-model="ipaddr_ipb"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_ipb()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_ipb"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号-->
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- IP地址-->

                <el-table-column
                  prop="IPADDR"
                  :label="$t('table1.ipAddress')"
                  width="120"
                >
                </el-table-column>
                <!-- 到期时间-->

                <el-table-column
                  prop="EXPIRE"
                  :label="$t('table1.expire')"
                  width="120"
                >
                </el-table-column>
                <!-- 描述-->

                <el-table-column prop="DESC" :label="$t('table1.description')">
                </el-table-column>
                <!-- 操作-->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_ipb"
                @current-change="handleCurrentChange_ipb"
                :current-page.sync="page_ipb"
                :page-sizes="this.q_page_size"
                :page-size="size_ipb"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_ipb"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu3"
              v-drag="{ handle: '.pop_up_text_cert_domain' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_cert_domain">
                <span class="span_pad"></span> {{ $t("table1.addbip") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.ipaddress") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ipaddr" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save31()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save32()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu3"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_ipb' }"
            >
              <div class="pop_up_text  pop_up_text_import_ipb">
                <span style="padding:0 14px"></span>{{ $t("table1.impbip") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange_ipb"
                      id="iupfile_ipb"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button
                  type="primary"
                  size="mini"
                  @click="save022_ipblack"
                  >{{ $t("tan.up") }}</el-button
                >
                <el-button type="danger" @click="save23()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- From白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.fromw") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加发件人白名单 -->

              <el-button
                @click="save4()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addws") }}</el-button
              >
              <!-- 导入发件人白名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.impws") }}</el-button
              >
              <!-- 导出发件人白名单 -->

              <el-button
                @click="daochu4()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.expws") }}</el-button
              >
              <span class="main_text"
                >{{ $t("anti_gs1.doemailaddress") }}:</span
              >
              <el-input
                v-model="email_senderw"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_senderw()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_emailw"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 域名或邮箱账号 -->

                <el-table-column prop="DNOREMAIL" :label="$t('table1.yuming')">
                </el-table-column>
                <!-- vip -->
                <el-table-column
                  prop="SHOW_IS_VIP"
                  :label="$t('anti_gs1.into_local1')"
                  v-if="this.isvip_show == 1"
                >
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick4(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_senderw"
                @current-change="handleCurrentChange_senderw"
                :current-page.sync="page_senderw"
                :page-sizes="this.q_page_size"
                :page-size="size_senderw"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_senderw"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu4"
              v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS_from' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS_from">
                <span style="padding:0 14px"></span>{{ $t("table1.addws") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- 域名或邮箱账号 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.doemailaddress") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="dnoremail" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.isvip_show == 1">
                  <!-- 加入本地网络vip-->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.into_local1") }} :
                  </div>
                  <div class="block block1">
                    <el-checkbox v-model="isvip1"></el-checkbox>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save41()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save42()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu4"></div>

            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_fromw' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromw">
                <span style="padding:0 14px"></span>{{ $t("table1.impws") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_fromw"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button type="primary" size="mini" @click="save022_from_b">{{
                  $t("tan.up")
                }}</el-button>
                <el-button type="danger" @click="save24()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- From黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.fromb") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加发件人黑名单 -->

              <el-button
                @click="save5()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addbs") }}</el-button
              >
              <!-- 导入发件人黑名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.impbs") }}</el-button
              >
              <!-- 导出发件人黑名单 -->

              <el-button
                @click="daochu5()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.expbs") }}</el-button
              >
              <span class="main_text"
                >{{ $t("anti_gs1.doemailaddress") }}:</span
              >
              <el-input
                v-model="email_senderb"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_senderb()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_emailb"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 域名或邮箱账号 -->

                <el-table-column prop="DNOREMAIL" :label="$t('table1.yuming')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick5(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_senderb"
                @current-change="handleCurrentChange_senderb"
                :current-page.sync="page_senderb"
                :page-sizes="this.q_page_size"
                :page-size="size_senderb"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_senderb"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu5"
              v-drag="{ handle: '.pop_up_text_local_domain' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_local_domain">
                <span class="span_pad"></span> {{ $t("table1.addbs") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- 域名或邮箱账号 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.doemailaddress") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="dnoremail" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save51()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save52()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu5"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_fromb' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromb">
                <span style="padding:0 14px"></span>{{ $t("table1.impbs") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_fromb"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button
                  type="primary"
                  size="mini"
                  @click="save022_from_black"
                  >{{ $t("tan.up") }}</el-button
                >
                <el-button type="danger" @click="save24()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 收件人白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.send_email") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加收件人白名单 -->

              <el-button
                @click="save10()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addrecws") }}</el-button
              >
              <!-- 导入收件人白名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.imprecws") }}</el-button
              >
              <!-- 导出收件人白名单 -->

              <el-button
                @click="daochu10_rec_white()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.exprecws") }}</el-button
              >
              <span class="main_text"
                >{{ $t("anti_gs1.doemailaddress") }}:</span
              >
              <el-input
                v-model="email_rec_w"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_rec_w()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_rec_w"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_rec_w"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 域名或邮箱账号 -->

                <el-table-column prop="RECIPIENT" :label="$t('table1.yuming')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick10_rec_white(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_rec_w"
                @current-change="handleCurrentChange_rec_w"
                :current-page.sync="page_rec_w"
                :page-sizes="this.q_page_size"
                :page-size="size_rec_w"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_rec_w"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu100"
              v-drag="{ handle: '.pop_up_text_addregex_eidt' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addregex_eidt">
                <span class="span_pad"></span> {{ $t("table1.addrecws") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- 域名或邮箱账号 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.doemailaddress") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="dnoremail"
                      placeholder="只能添加本地收件人"
                      clearable
                    ></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save101_rec_white()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save102()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu100"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_Upload' }"
            >
              <div class="pop_up_text  pop_up_text_Upload">
                <span style="padding:0 14px"></span>{{ $t("table1.imprecws") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_recip_white"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button
                  type="primary"
                  size="mini"
                  @click="save022_rec_white"
                  >{{ $t("tan.up") }}</el-button
                >
                <el-button type="danger" @click="save24()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 收件人黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.Recipient") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加收件人黑名单 -->

              <el-button
                @click="save10()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addbr") }}</el-button
              >
              <!-- 导入收件人黑名单 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.impbr") }}</el-button
              >
              <!-- 导出收件人黑名单 -->

              <el-button
                @click="daochu10()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.expbr") }}</el-button
              >
              <span class="main_text"
                >{{ $t("anti_gs1.doemailaddress") }}:</span
              >
              <el-input
                v-model="email_rec_b"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_rec_b()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_rec_b"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList10"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 域名或邮箱账号 -->

                <el-table-column prop="RECIPIENT" :label="$t('table1.yuming')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick10(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_rec_b"
                @current-change="handleCurrentChange_rec_b"
                :current-page.sync="page_rec_b"
                :page-sizes="this.q_page_size"
                :page-size="size_rec_b"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_rec_b"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu100"
              v-drag="{ handle: '.pop_up_text_addb' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addb">
                <span class="span_pad"></span> {{ $t("table1.addbr") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- 域名或邮箱账号 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.doemailaddress") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="dnoremail"
                      placeholder=""
                      clearable
                    ></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button type="primary" @click="save101()">{{
                  $t("tab.save")
                }}</el-button>
                <!-- 取消-->

                <el-button type="danger" @click="save102()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu100"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_br' }"
            >
              <div class="pop_up_text  pop_up_text_import_br">
                <span style="padding:0 14px"></span>{{ $t("table1.impbr") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_recip"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button type="primary" size="mini" @click="save022_recip">{{
                  $t("tan.up")
                }}</el-button>
                <el-button type="danger" @click="save24()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- Url黑名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.urlb") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加Url黑名单 -->

              <el-button
                @click="save6()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addub") }}</el-button
              >
                <span class="main_text"
                >url:</span
              >
              <el-input
                v-model="url_b_list"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_url_b()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_url_b"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>

                <!-- url -->

                <el-table-column prop="URL" :label="$t('table1.url')">
                </el-table-column>
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick6(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
               <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_url_b"
                @current-change="handleCurrentChange_url_b"
                :current-page.sync="page_url_b"
                :page-sizes="this.q_page_size"
                :page-size="size_url_b"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_url_b"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_url_b' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_url_b">
                <span class="span_pad"></span> {{ $t("table1.addub") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!--  Url黑名单:  -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.BlackURL") }} :
                  </div>

                  <div class="block block1">
                    <el-input v-model="url" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--策略类型 -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.Policytype") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="type_url" placeholder="请选择">
                      <el-option
                        v-for="item in type12"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save61()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save62()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- Url白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.urlw") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加Url白名单 -->

              <el-button
                @click="save7()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.adduw") }}</el-button
              >
                <span class="main_text"
                >url:</span
              >
              <el-input
                v-model="url_w_list"
                placeholder=""
                clearable
              ></el-input>
              <el-button
                @click="search_url_w()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table.search") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02 table_fenye">
              <el-table
                ref="multipleTable_url_w"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList7"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>

                <!-- url -->

                <el-table-column prop="URL" :label="$t('table1.url')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick7(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
                <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange_url_w"
                @current-change="handleCurrentChange_url_w"
                :current-page.sync="page_url_w"
                :page-sizes="this.q_page_size"
                :page-size="size_url_w"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums_url_w"
              ></el-pagination>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_url_w' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_url_w">
                <span class="span_pad"></span> {{ $t("table1.adduw") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!--  Url白名单:  -->

                  <div class="find-text" style="padding-right:12px">
                    {{ $t("anti_gs1.WhiteURL") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="url" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save71()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save72()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 内容白名单 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("tabs.regexw") }}</span>
          <div class="main">
            <p class="title_state">
              <!-- 增加内容白名单 -->

              <el-button
                @click="save8()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addwcr") }}</el-button
              >
             
            </p>
          </div>
          <div class="switch1">
            <div class="table table02">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList8"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 表达式类型 -->

                <el-table-column
                  prop="SHOWTYPE"
                  :label="$t('table1.type')"
                  width="120"
                >
                </el-table-column>
                <!-- 分数 -->

                <el-table-column
                  prop="SCORE"
                  :label="$t('table1.score')"
                  width="120"
                >
                </el-table-column>
                <!-- 正则表达式过滤规则 -->

                <el-table-column prop="REGEX" :label="$t('table1.rule')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick8(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->

                    <el-button
                      type="text"
                      size="small"
                      @click="save801(scope.$index, scope.row)"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_url_wrc' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_url_wrc">
                <span class="span_pad"></span> {{ $t("table1.addwcr") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!-- 类型 -->

                  <div class="find-text" style="padding-right:12px;width:140px">
                    {{ $t("anti_gs1.User_type") }} :
                  </div>
                  <div class=" block block1">
                    <el-select v-model="type">
                      <el-option
                        v-for="item in type17"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <!-- 正则表达式过滤规则 -->
                  <div class="find-text" style="padding-right:12px;width:140px">
                    {{ $t("anti_gs1.RegexRule") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="filterwhiteregex"
                      placeholder=""
                    ></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save81()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save82()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu81" v-drag="{ handle: '.pop_up_text_derived_record' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_derived_record">
                <span class="span_pad"></span> {{ $t("table1.addwcr_edit") }}
              </div>
              <p></p>
              <div class="find">
                <div>
                  <div class="find1">
                    <!-- 类型 -->

                    <div
                      class="find-text"
                      style="padding-right:12px;width:140px"
                    >
                      {{ $t("anti_gs1.User_type") }} :
                    </div>
                    <div class=" block block1">
                      <el-select v-model="type">
                        <el-option
                          v-for="item in type17"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div class="find1">
                    <!-- 正则表达式过滤规则 -->
                    <div
                      class="find-text"
                      style="padding-right:12px;width:140px"
                    >
                      {{ $t("anti_gs1.RegexRule") }}:
                    </div>
                    <div class="block block1">
                      <el-input
                        v-model="filterwhiteregex"
                        placeholder=""
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save810()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save820()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu81"></div>
          </div>
        </el-tab-pane>
        <!-- 防伪名字列表 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("tabs.avoid") }}</span>
          <div class="main">
            <p>
              <!-- 增加防伪名字 -->

              <el-button
                @click="save9()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.addnamef") }}</el-button
              >

              <!-- 上传防伪明细列表文件 -->

              <el-button
                @click="daoru()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("table1.upnf") }}</el-button
              >
              <!-- 设置防伪提示 -->

              <el-button
                :disabled="$root.jurisdiction.only_query == 0"
                @click="save929()"
                >{{ $t("table1.addfs") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div class="table table02">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList9"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 序号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="120"
                >
                </el-table-column>
                <!-- 防伪名字 -->

                <el-table-column prop="NAME" :label="$t('table1.forge')">
                </el-table-column>
                <!-- 操作 -->

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick9(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu9"
              v-drag="{ handle: '.pop_up_text_forgename' }"
            >
              <!--  上传防伪。名字列表-->
              <div class="pop_up_text pop_up_text_forgename">
                <span class="span_pad"></span> {{ $t("table1.addnamef") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- 防伪名字 -->

                    {{ $t("table1.forge") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="forgename" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save91()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save92()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu9"></div>
            <div
              class="pop-up"
              v-show="tanchu92"
              v-drag="{ handle: '.pop_up_text_forgename1' }"
            >
              <!--  设置防伪提示-->
              <div class="pop_up_text pop_up_text_forgename1">
                <span class="span_pad"></span> {{ $t("table1.addfs") }}
              </div>
              <p></p>
              <div class="find" v-loading="load_forgename_test">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- 主题增加标记 -->

                    {{ this.forgename_value_text }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="forgename_value"
                      placeholder="请选择"
                      style="width:140px"
                      @change="for_chang_value"
                    >
                      <el-option
                        v-for="item in forgename_value_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- 主题增加标记 -->

                    {{ this.add_forge_sub_hint_on_text }}:
                  </div>
                  <div class="block block1">
                    <el-checkbox v-model="add_forge_sub_hint_on"></el-checkbox>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    <!-- 主题增加标记 -->

                    {{ this.add_sub_text }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="add_sub" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <!-- 保存-->

                <el-button
                  type="primary"
                  @click="save921()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("tab.save") }}</el-button
                >
                <!-- 取消-->

                <el-button type="danger" @click="save922()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu92"></div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_iup' }"
            >
              <div class="pop_up_text  pop_up_text_import_iup">
                <span style="padding:0 14px"></span>{{ $t("table1.upnf") }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <!-- ip地址-->

                  <div class="find-text" style="padding-right:12px"></div>
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_forge"
                      class="iupfile"
                      ref="clearFile"
                      accept=".txt"
                    />
                  </div>
                </div>
              </div>
              <el-row>
                <el-button
                  type="primary"
                  size="mini"
                  @click="save022_forge_list"
                  >{{ $t("tan.up") }}</el-button
                >
                <el-button type="danger" @click="save24()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      isvip: "",
      isvip1: "",
      isvip_show: "",
      // 内容过滤
      policy_type: [],
      policy_type1: [],
      type1: [],
      filterregex: "",
      score: "",
      regex_type: "",
      tanchu2: false,
      tanchu3: false,
      tanchu4: false,
      tanchu5: false,
      tanchu9: false,
      tanchu100: false,
      header_key: "",
      keyyin: false,
      bian_bao: "",
      bian_bao_type: "",
      bian_bao_policy: "",
      // bainji
      mbian_bao_type: "",
      mbian_bao_policy: "",
      //ip 白名单
      ipaddr: "",
      ipaddr_ipb: "",
      email_senderw: "",
      email_senderb: "",
      email_rec_w: "",
      email_rec_b: "",
      url_b_list: "",
      url_w_list: "",

      dnoremail: "",
      url: "",
      type: "",
      filterwhiteregex: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",
      sid11: "",
      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      tanchu1: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      fileList8: [],
      fileList9: [],
      fileList10: [],
      fileList_rec_w: [],
      add_sub: "",
      add_sub_text: "",
      forgename: "",
      tanchu92: false,
      tanchu81: false,
      load_forgename_test: false,
      radio: [],
      type11: [],
      type12: [],
      type13: [],
      type15: [],
      type16: [],
      type17: [],
      type18: [],
      files: "",
      files_ipb: "",
      type_url: 0,
      loading: false,
      loading1: false,
      input_show: false,
      forgename_value: "",
      forgename_value_text: "",
      forgename_value_arr: [],
      add_forge_sub_hint_on: "",
      add_forge_sub_hint_on_text: "",
      data_loadok: "",
      showall: 1,
      // 总数
      totalnums: 0,
      totalnums_ipb: 0,
      totalnums_senderw: 0,
      totalnums_senderb: 0,
      totalnums_rec_w: 0,
      totalnums_rec_b: 0,
      totalnums_url_b: 0,
      totalnums_url_w: 0,
      size: 0,
      size_ipb: 0,
      size_senderw: 0,
      size_senderb: 0,
      size_rec_w: 0,
      size_rec_b: 0,
      size_url_b: 0,
      size_url_w: 0,
      // 每页条数
      pagesize: 0,
      pagesize_ipb: 0,
      pagesize_senderw: 0,
      pagesize_senderb: 0,
      pagesize_rec_w: 0,
      pagesize_rec_b: 0,
      pagesize_url_b: 0,
      pagesize_url_w: 0,
      //   默认前往第几页
      page: 1,
      page_ipb: 1,
      page_senderw: 1,
      page_senderb: 1,
      page_rec_w: 1,
      page_rec_b: 1,
      page_url_b: 1,
      page_url_w: 1,
      q_page_size: [],
    };
  },
  mounted() {
    this.getFileList_content_filter(); //内容过滤
    this.getFileList_ipw();
    this.getFileList_ipb();
    this.getFileList_senderw(); //发件人白名单
    this.getFileList_black_sender(); // 发件人黑名单
    this.getFileList_rec_black(); // 收件人黑名单
    this.getFileList_rec_white(); // 收件人白名单

    this.getFileList_b_url(); //url 黑名单
    this.getFileList_url_w(); //url 白名单
    this.getFileList_center_white(); // 内容白名单
    this.getFileList_anti_fake(); // 防伪名字
  },
  methods: {
    dianji() {
      // this.ipaddr="";
      // this.ipaddr_ipb="";
      // this.email_senderw="";
      // this.email_senderb="";
    },
    for_chang_value(value) {
      console.log(value);
      if (value == "SETSUB") {
        this.input_show = true;
      } else {
        this.input_show = false;
      }
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    changyin01(a) {
      // console.log(a);

      if (a == "HEADERS") {
        this.keyyin = true;
      } else {
        this.keyyin = false;
      }
    },
    changyin(a) {
      // console.log(a);
      this.bian_bao_type = a;
      if (a == "HEADERS") {
        this.keyyin = true;
      } else {
        this.keyyin = false;
      }
    },
    changyin1(a) {
      // console.log(a);
      this.bian_bao_policy = a;
    },
    // 不需要
    onChange() {
      let ipt = document.getElementById("iupfile");
      console.log(ipt.files[0]);
      this.file = ipt.files[0];
      console.log(this.file);
    },
    inputFileChange_ipb(e) {
      this.files_ipb = e.target.files[0];
      // console.log(this.files_ipb,'files_ipb');
    },
    inputFileChange(e) {
      this.files = e.target.files[0];
      // console.log(this.files,'fangwei');
    },
    // 收件人黑名单上传
    save022_recip() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_blrecipient");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_rec_black();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            console.log(this.files);

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // 收件人白名单上传
    save022_rec_white() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_wlrecipient");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/bspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_rec_white();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            console.log(this.files);

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // 防伪名字列表上传
    save022_forge_list() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_forgename");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            // this.loading = false;

            this.getFileList_anti_fake();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            // console.log(this.files)

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // From黑名单增加
    save022_from_black() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;

        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_blsender");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_black_sender();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            // console.log(this.files)

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // From白名单增加
    save022_from_b() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;

        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_wlsender");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_senderw();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            // console.log(this.files)

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // 白名单增加
    save022_ipblack() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files_ipb;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files_ipb.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;

        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_ipbl");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          // console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_ipb();

            this.$refs.clearFile.value = ""; // 清空file文件
            this.files_ipb = "";

            console.log(this.files_ipb);

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
        });
      }
    },
    // 白名单增加
    save022() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;

        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_ipwl");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          console.log(res);
          this.loading = false;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList_ipw();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";

            this.$message({
              type: "success",
              message: `${res.data.ret}`,
            });
          }
        });
      }
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 显示
    tan: function() {
      this.tanchu = true;
      this.filterregex = "";
      this.keyyin = false;
      this.score = 10;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    // 内容过滤加载
    getFileList_content_filter() {
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_regex",
            sid: sid,
            showall: 1,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList1 = res.data.ret.datalist;
            this.type11 = res.data.ret.q_regex_type;
            this.type12 = res.data.ret.q_policy_type;
            this.type = res.data.ret.q_regex_type[0].value;
            this.policy_type = res.data.ret.q_policy_type[0].value;
            this.score = 10;
            this.type1 = this.type;
            this.policy_type1 = this.policy_type;
            this.header_key = "";
            this.loading1 = false;
          }
        });
    },
    save11() {
      this.tanchu = false;
    },
    //内容编辑
    save01(index, scope) {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let REAL_ADDR = scope.REGEX_ID;
      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "edit_regex",
            sid: sid,
            regex_id: REAL_ADDR,
          },
        })
        .then((res) => {
          // console.log(res);
          this.tanchu1 = true;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            if (res.data.ret.HEADER_KEY != "") {
              this.keyyin = true;
            } else {
              this.keyyin = false;
            }

            this.type15 = res.data.ret.q_regex_type;
            this.type16 = res.data.ret.q_policy_type;
            this.score = res.data.ret.SCORE;
            this.filterregex = res.data.ret.REGEX;
            this.type = res.data.ret.regex_type;
            this.header_key = res.data.ret.HEADER_KEY;
            this.policy_type = res.data.ret.policy_type;
            this.bian_bao = res.data.ret.REGEX_ID;
            this.mbian_bao_type = res.data.ret.regex_type;
            this.mbian_bao_policy = res.data.ret.policy_type;
            // console.log(this.type)
            // console.log(this.policy_type)
          }
        });
      // console.log(index, scope);
    },
    // 内容编辑保存
    save001() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let header_key = this.header_key;
      let type = this.type;
      let score = this.score;
      let filterregex = this.filterregex;
      let policy_type = this.policy_type;

      let REAL_ADDR = this.bian_bao;
      let str = this.$qs.stringify({
        __mode: "save_regex",
        sid: sid,
        regex_id: REAL_ADDR,
        type: type,
        score: score,
        filterregex: filterregex,
        policy_type: policy_type,
        header_key: header_key,
        newadd: 0,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        this.$close_hint_test();
        this.$close_disable_hint_test();
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu1 = false;

          this.loading1 = false;
          this.getFileList_content_filter();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 内容编辑取消
    save002() {
      this.tanchu1 = false;
      this.filterregex = "";
      this.type = this.type1;
      this.policy_type = this.policy_type1;
      this.score = 10;
    },
    // 内容过滤保存
    save1() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let type = this.type;
      let score = this.score;
      let filterregex = this.filterregex;
      let policy_type = this.policy_type;
      let header_key = this.header_key;
      let str = this.$qs.stringify({
        __mode: "save_regex",
        sid: sid,
        header_key: header_key,
        type: type,
        score: score,
        filterregex: filterregex,
        policy_type: policy_type,
        newadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;

          this.loading1 = false;
          this.getFileList_content_filter();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 内容过滤删除
    handleClick1(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let REAL_ADDR = scope.REGEX_ID;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_regex",
                sid: sid,

                regex_id: REAL_ADDR,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading1 = false;
                this.getFileList_content_filter();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_ipw(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      this.pagesize = val;
this.search_ipw()

    },
    // 当前第几页
    handleCurrentChange_ipw(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page = val;
this.search_ipw()
    },
    search_ipw() {
      if (this.ipaddr == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }
      this.getFileList_ipw();
    },
    // ip白名单加载
    getFileList_ipw() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_ipwl",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize,
            page: this.page,
            ipaddr: this.ipaddr,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.isvip_show = res.data.ret.SYS_ADD_IPWL_INTO_LOCAL_ON;
            this.totalnums = res.data.ret.totalnums;
            this.size = res.data.ret.pagesize;
            this.page = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_ipw.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    readFile(file) {
      return new Promise(function() {
        let reader = new FileReader();
        reader.readAsText(file);
      });
    },
    fileChange() {
      let file = document.getElementById("uploadFile").files[0];
      let vm = this;
      this.readFile(file).then((res) => {
        let arr = res.split(/[\n]/);
        arr.forEach((item, index) => {
          let arr2 = item.split("----");
          let obj = {
            name: arr2[0],
            sex: arr2[1],
            age: arr2[2],
          };
          vm.$set(vm.fileData, index, obj); //这里一定要用Vue.set(),不然视图不会更新
        });
        vm.dialog2Visible = true; //显示一个dialog里面放一个table，将this.fileData的数据与之绑定即可
      });
    },
    save2() {
      this.isvip = false;
      this.ipaddr = "";
      this.tanchu2 = true;
    },
    save23() {
      this.$refs.clearFile.value = "";
      this.tanchu = false;
    },
    // ip白名单保存
    save21() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let ipaddr = this.ipaddr;
      let str = this.$qs.stringify({
        __mode: "save_ipwl",
        sid: sid,
        ipaddr: ipaddr,
        isvip: this.isvip == true ? 1 : 0,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu2 = false;

          this.loading = false;
          this.getFileList_ipw();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.ipaddr = "";
    },
    save22() {
      this.tanchu2 = false;
    },
    save24() {
      this.tanchu = false;
    },
    // ip白名单导出
    daochu() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_ipwl";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // ip白名单 导入
    daoru() {
      // console.log('aa')
      this.tanchu = true;
      this.$refs.clearFile.value = "";

      document.getElementById("iupfile").value = "";
      document.getElementById("iupfile_ipb").value = "";
      document.getElementById("iupfile_fromw").value = "";
      document.getElementById("iupfile_fromb").value = "";
      document.getElementById("iupfile_recip").value = "";
      document.getElementById("iupfile_recip_white").value = "";
      document.getElementById("iupfile_forge").value = "";

      // this.files = ''
      // this.files_ipb = ''
    },
    daoru1() {
      this.tanchu = false;
      // return false;
      var FR = document.forms["f_upload_ipwl"];
      FR.submit();
      this.getFileList_ipw();

      return false;
    },
    // ip白名单删除
    handleClick2(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ORGIP = scope.ORGIP;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ipwl",
                sid: sid,
                wlip: ORGIP,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_ipw();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_ipb(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      this.pagesize_ipb = val;
this.search_ipb()
    },
    // 当前第几页
    handleCurrentChange_ipb(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_ipb = val;
this.search_ipb()
    },
    search_ipb() {
      if (this.ipaddr_ipb == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }

      this.getFileList_ipb();
    },
    // ip黑名单加载
    getFileList_ipb() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_ipbl",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize_ipb,
            page: this.page_ipb,
            ipaddr: this.ipaddr_ipb,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList3 = res.data.ret.datalist;
            this.totalnums_ipb = res.data.ret.totalnums;
            this.size_ipb = res.data.ret.pagesize;
            this.page_ipb = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_ipb.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    // ip黑名单保存
    save31() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let ipaddr = this.ipaddr;
      let str = this.$qs.stringify({
        __mode: "save_ipbl",
        sid: sid,
        ipaddr: ipaddr,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu3 = false;

          this.loading = false;
          this.getFileList_ipb();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.ipaddr = "";
    },
    save3() {
      this.ipaddr = "";
      this.tanchu3 = true;
    },
    save32() {
      this.tanchu3 = false;
    },
    // ip黑名单导出
    daochu3() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_ipbl";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // ip黑名单删除
    handleClick3(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let ORGIP = scope.ORGIP;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_ipbl",
                sid: sid,
                blip: ORGIP,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_ipb();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_senderw(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      this.pagesize_senderw = val;
this.showall=0;
      // console.log(this.col, "给后台返回数据2");

      this.getFileList_senderw();
    },
    // 当前第几页
    handleCurrentChange_senderw(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_senderw = val;
this.showall=0;
      this.getFileList_senderw();
    },
    search_senderw() {
      if (this.email_senderw == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }
      this.getFileList_senderw();
    },
    // FORM白名单加载
    getFileList_senderw() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_allwlsender",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize_senderw,
            page: this.page_senderw,
            email: this.email_senderw,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList4 = res.data.ret.datalist;
            this.totalnums_senderw = res.data.ret.totalnums;
            this.size_senderw = res.data.ret.pagesize;
            this.page_senderw = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_emailw.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //FORM白名单保存
    save41() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.dnoremail;
      let str = this.$qs.stringify({
        __mode: "save_wlsender",
        sid: sid,
        dnoremail: dnoremail,
        isvip: this.isvip1 == true ? 1 : 0,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu4 = false;

          this.loading = false;
          this.getFileList_senderw();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.ipaddr = "";
    },
    save4() {
      this.tanchu4 = true;
      this.dnoremail = "";
      this.isvip1 = false;
    },
    save42() {
      this.tanchu4 = false;
    },
    // FORM白名单导出
    daochu4() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_wlsender";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // FORM白名单删除
    handleClick4(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.DNOREMAIL;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_wlsender",
                sid: sid,
                dnoremail: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_senderw();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_senderb(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      // console.log(val)
      this.pagesize_senderb = val;
this.search_senderb()
    },
    // 当前第几页
    handleCurrentChange_senderb(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_senderb = val;
this.search_senderb()

    },
    search_senderb() {
      if (this.email_senderb == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }
      this.getFileList_black_sender();
    },
    // FORM黑名单加载
    getFileList_black_sender() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_allblsender",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize_senderb,
            page: this.page_senderb,
            email: this.email_senderb,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList5 = res.data.ret.datalist;
            this.totalnums_senderb = res.data.ret.totalnums;
            this.size_senderb = res.data.ret.pagesize;
            this.page_senderb = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_emailb.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //FORM黑名单保存
    save51() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.dnoremail;
      let str = this.$qs.stringify({
        __mode: "save_blsender",
        sid: sid,
        dnoremail: dnoremail,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu5 = false;

          this.loading = false;
          this.getFileList_black_sender();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.ipaddr = "";
    },
    save5() {
      this.tanchu5 = true;
      this.dnoremail = "";
    },
    save52() {
      this.tanchu5 = false;
    },
    // FORM黑名单导出
    daochu5() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_blsender";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // FORM黑名单删除
    handleClick5(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.DNOREMAIL;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_blsender",
                sid: sid,
                dnoremail: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_black_sender();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
        // 每页显示多少条 -- 切换
    handleSizeChange_url_b(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      // console.log(val)
      this.pagesize_url_b = val;
this.search_url_b()
    },
    // 当前第几页
    handleCurrentChange_url_b(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_url_b = val;
this.search_url_b()

    },
    search_url_b() {
      // if (this.url_b_list == "") {
      //   this.showall = 1;
      // } else {
      //   this.showall = 0;
      // }
      this.getFileList_b_url();
    },
    // url黑名单加载
    getFileList_b_url() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_allblurl",
            sid: sid,
       
            pagesize: this.pagesize_url_b,
            page: this.page_url_b,
            url: this.url_b_list,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList6 = res.data.ret.datalist;
              this.totalnums_url_b = res.data.ret.totalnums;
            this.size_url_b = res.data.ret.pagesize;
            this.page_url_b = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_url_b.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //url黑名单保存
    save61() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.url;
      let str = this.$qs.stringify({
        __mode: "save_blurl",
        sid: sid,
        url: dnoremail,
        type: this.type_url,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;

          this.loading = false;
          this.getFileList_b_url();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      // this.url = "";
    },
    save6() {
      this.tanchu = true;
      this.url = "";
      this.type_url = 0;
    },
    save62() {
      this.tanchu = false;
    },
    // url黑名单删除
    handleClick6(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.URL;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_blurl",
                sid: sid,
                url: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_b_url();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
          // 每页显示多少条 -- 切换
    handleSizeChange_url_w(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      // console.log(val)
      this.pagesize_url_w = val;
this.search_url_w()
    },
    // 当前第几页
    handleCurrentChange_url_w(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_url_w = val;
this.search_url_w()

    },
    search_url_w() {
      // if (this.email_url_w == "") {
      //   this.showall = 1;
      // } else {
      //   this.showall = 0;
      // }
      this.getFileList_url_w();
    },
    // url白名单加载
    getFileList_url_w() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_allwlurl",
            sid: sid,
            
            pagesize: this.pagesize_url_w,
            page: this.page_url_w,
            url: this.url_w_list,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList7 = res.data.ret.datalist;
                 this.totalnums_url_w = res.data.ret.totalnums;
            this.size_url_w = res.data.ret.pagesize;
            this.page_url_w = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_url_w.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //url白名单保存
    save71() {
      this.$disable_hint_test();
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.url;
      let str = this.$qs.stringify({
        __mode: "save_wlurl",
        sid: sid,
        url: dnoremail,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;

          this.loading = false;
          this.getFileList_url_w();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    save7() {
      this.tanchu = true;
      this.url = "";
    },
    save72() {
      this.tanchu = false;
    },
    // url白名单删除
    handleClick7(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.URL;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_wlurl",
                sid: sid,
                url: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_url_w();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 内容白名单加载
    getFileList_center_white() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_whiteregex",
            sid: sid,
            showall: 1,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList8 = res.data.ret.datalist;
            this.type17 = res.data.ret.q_whiteregex_type;
            this.loading = false;

            // console.log(this.type13)
          }
        });
    },
    //内容白名单保存
    save81() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.type;
      let dnoremail1 = this.filterwhiteregex;
      let str = this.$qs.stringify({
        __mode: "save_whiteregex",
        sid: sid,
        filterwhiteregex: dnoremail1,
        type: dnoremail,
        newadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;

          this.loading = false;
          this.getFileList_center_white();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.url = "";
    },
    save8() {
      this.tanchu = true;
      // this.type = '主题'
      this.filterwhiteregex = "";
      this.type = "SUBJECT";
    },
    save82() {
      this.tanchu = false;
    },
    //内容白名单编辑
    save801(index, scope) {
      // this.tanchu81 = true
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let REAL_ADDR = scope.REGEX_ID;
      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "edit_whiteregex",
            sid: sid,
            regex_id: REAL_ADDR,
          },
        })
        .then((res) => {
          console.log(res);
          this.tanchu81 = true;

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            if (res.data.ret.HEADER_KEY != "") {
              this.keyyin = true;
            } else {
              this.keyyin = false;
            }

            this.filterwhiteregex = res.data.ret.REGEX;
            this.type18 = res.data.ret.q_regex_type;
            this.type = res.data.ret.regex_type;

            this.bian_bao = res.data.ret.REGEX_ID;
            this.mbian_bao_type = res.data.ret.regex_type;

            // console.log(this.type)
            // console.log(this.policy_type)
          }
        });
      // console.log(index, scope);
    },
    // 内容白名单编辑保存
    save810() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let type = this.type;
      let score = this.score;
      let filterwhiteregex = this.filterwhiteregex;

      // console.log(type, 'type')
      // console.log(policy_type, 'policy_type')
      // console.log(this.bian_bao_type, '点击后的type')
      // console.log(this.bian_bao_policy, '点击后的policy')
      // console.log(this.type1)
      // console.log(this.policy_type1)

      let REAL_ADDR = this.bian_bao;
      let str = this.$qs.stringify({
        __mode: "save_whiteregex",
        sid: sid,
        regex_id: REAL_ADDR,
        type: type,
        score: score,
        filterwhiteregex: filterwhiteregex,
        newadd: 0,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu81 = false;

          this.loading = false;
          this.getFileList_center_white();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    //内容白名单编辑取消
    save820() {
      this.tanchu81 = false;
      this.filterregex = "";
      this.type = this.type1;
      this.policy_type = this.policy_type1;
      this.score = 10;
    },
    // 内容白名单删除
    handleClick8(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.REGEX_ID;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_whiteregex",
                sid: sid,
                regex_id: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_center_white();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 防伪名字加载
    getFileList_anti_fake() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_forgename",
            sid: sid,
            showall: 1,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.add_forge_sub_hint_on =
              res.data.ret.ADD_FORGE_SUB_HINT_ON == 0 ? false : true;
            this.add_forge_sub_hint_on_text =
              res.data.ret.forge_add_sub_hint_on;
            this.add_sub = res.data.ret.FILTER_ADD_FORGE_NAME;
            this.add_sub_text = res.data.ret.add_gl_subject_tag;
            this.forgename_value = res.data.ret.FORGENAME_ACTION;
            this.data_loadok = res.data.ret.data_loadok;
            this.forgename_value_text = res.data.ret.forge_action;
            this.forgename_value_arr = res.data.ret.q_action;
            this.fileList9 = res.data.ret.datalist;
            this.loading = false;
          }
        });
    },
    //防伪名字保存
    save91() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.forgename;
      let str = this.$qs.stringify({
        __mode: "save_forgename",
        sid: sid,
        forgename: dnoremail,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu9 = false;

          this.loading = false;
          this.getFileList_anti_fake();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.url = "";
    },
    save9() {
      this.tanchu9 = true;
      this.forgename = "";
    },
    save92() {
      this.tanchu9 = false;
    },
    // 防伪名字删除
    handleClick9(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.BASE64_NAME;
          let dnoremail1 = scope.FORGE_NAME_ID;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_forgename",
                sid: sid,
                forgename: dnoremail,
                id: dnoremail1,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_anti_fake();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    save929() {
      this.tanchu92 = true;
      //             this.load_forgename_test=true;
      //             let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      //             let dnoremail = this.add_sub;

      //             this.$axios
      //                 .get("/api/adm/cgi/newspam.cgi", {
      //                     params: {
      //                         __mode: "set_forge_sub",
      //                         sid: sid,
      //                         add_sub: dnoremail,
      //                     },
      //                 })
      //                 .then((res) => {
      //                     // console.log(res);
      // this.load_forgename_test=false;
      //                     if (!res.data.fmstatus) {
      //                         alert(res.data);
      //                     } else if (res.data.fmstatus.code == "1") {
      //                         alert(res.data.fmstatus.errmsg);
      //                     } else if (res.data.fmstatus.code == "2") {
      //                         alert(res.data.fmstatus.errmsg);
      //                         this.getFileList_anti_fake();
      //                     } else if (res.data.fmstatus.code == "3") {
      //                         alert(res.data.fmstatus.errmsg);
      //                         this.$router.push({
      //                             name: "login",
      //                         });
      //                     } else {

      //                         this.loading = false;

      //                     }
      //                 })
    },
    save922() {
      this.tanchu92 = false;
    },
    //防伪明细列表保存
    save921() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_forge_param",
        sid: sid,
        add_sub: this.add_sub,
        data_loadok: this.data_loadok,
        add_forge_sub_hint_on: this.add_forge_sub_hint_on == true ? 1 : 0,
        forge_action: this.forgename_value,
      });
      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu92 = false;

          this.loading = false;
          this.getFileList_anti_fake();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.url = "";
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_rec_w(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      // console.log(val)
      this.pagesize_rec_w = val;
this.search_rec_w()

    },
    // 当前第几页
    handleCurrentChange_rec_w(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_rec_w = val;
this.search_rec_w()
    },
    search_rec_w() {
      if (this.email_rec_w == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }
      this.getFileList_rec_white();
    },
    // 收件人白名单加载
    getFileList_rec_white() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/bspam.cgi", {
          params: {
            __mode: " list_allwlrecipient",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize_rec_w,
            page: this.page_rec_w,
            email: this.email_rec_w,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList_rec_w = res.data.ret.datalist;
            this.totalnums_rec_w = res.data.ret.totalnums;
            this.size_rec_w = res.data.ret.pagesize;
            this.page_rec_w = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_rec_w.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //收件人白名单保存
    save101_rec_white() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.dnoremail;
      let str = this.$qs.stringify({
        __mode: "save_wlrecipient",
        sid: sid,
        dnoremail: dnoremail,
      });
      this.$axios.post("/api/adm/cgi/bspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu100 = false;

          this.loading = false;
          this.getFileList_rec_white();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.url = "";
    },
    // 每页显示多少条 -- 切换
    handleSizeChange_rec_b(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      // console.log(val)
      this.pagesize_rec_b = val;
this.search_rec_b()
      // console.log(this.col, "给后台返回数据2");

     
    },
    // 当前第几页
    handleCurrentChange_rec_b(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page_rec_b = val;
    this.search_rec_b()

    
    },
    search_rec_b() {
      if (this.email_rec_b == "") {
        this.showall = 1;
      } else {
        this.showall = 0;
      }
      this.getFileList_rec_black();
    },
    // 收件人黑名单加载
    getFileList_rec_black() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_allblrecipient",
            sid: sid,
            showall: this.showall,
            pagesize: this.pagesize_rec_b,
            page: this.page_rec_b,
            email: this.email_rec_b,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList10 = res.data.ret.datalist;
            this.totalnums_rec_b = res.data.ret.totalnums;
            this.size_rec_b = res.data.ret.pagesize;
            this.page_rec_b = res.data.ret.page;
            this.q_page_size = res.data.ret.q_pagesize;
            this.$nextTick(() => {
              this.$refs.multipleTable_rec_b.bodyWrapper.scrollTop = 0;
            });
            this.loading = false;
          }
        });
    },
    //收件人黑名单保存
    save101() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let dnoremail = this.dnoremail;
      let str = this.$qs.stringify({
        __mode: "save_blrecipient",
        sid: sid,
        dnoremail: dnoremail,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu100 = false;

          this.loading = false;
          this.getFileList_rec_black();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.url = "";
    },
    save10() {
      this.tanchu100 = true;
      this.dnoremail = "";
    },
    save102() {
      this.tanchu100 = false;
    },
    // 收件人白名单删除
    handleClick10_rec_white(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.RECIPIENT;

          this.$axios
            .get("/api/adm/cgi/bspam.cgi", {
              params: {
                __mode: "del_wlrecipient",
                sid: sid,
                dnoremail: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_rec_white();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 收件人白名单导出
    daochu10_rec_white() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_wlrecipient";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/bspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // 收件人黑名单删除
    handleClick10(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let dnoremail = scope.RECIPIENT;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_blrecipient",
                sid: sid,
                dnoremail: dnoremail,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList_rec_black();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 收件人黑名单导出
    daochu10() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "download_blrecipient";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);
    },
  },
};
</script>

<style lang="less" scoped>
// IP白名单
.table02 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(3) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(5) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(3) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(5) {
    text-align: center;
  }
}

// 内容过滤
.table01 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(6) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(7) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(6) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(7) {
    text-align: center;
  }
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/fengye.less";

@import "../../css/pou_up.less";
@import "../../css/drag.less";
.pop-up .pop_up_text_ROUTE_ADDRESS,
.pop-up .pop_up_text_ROUTE_ADDRESS_from {
  width: 100%;
}
.pop_up_text_ROUTE_ADDRESS,
.pop_up_text_ROUTE_ADDRESS_from {
  background: #eee;
}
</style>
